<template>
  <div class="nup_main">
    <div class="new_content">
      <div class="new_webposition"><router-link :to="{ path: '/usercenter'}">学习中心</router-link><span class="nje_jiange">&gt;</span><span class="nje_last">我的考试</span></div>

      <el-tabs v-model="activeName1" type="card" @tab-click="handleClick" style="margin-top:20px;">
        <el-tab-pane label="培训班考试" name="first">
          <!--培训班考试 ：考试列表-->
          <exam-table-page :bindType="bindType"></exam-table-page>
        </el-tab-pane>
        <el-tab-pane label="我的考试" name="second">
          <!--我的考试 ：考试列表-->
          <exam-table-page :bindType="bindType"></exam-table-page>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
  import  examTablePage from '../../components/ExamTablePage'
  export default {
    components: {
      examTablePage
    },
    data () {
      return {
        bindType:'2',
        examListInit:[],
        listLoading:false,
        activeName1:'first',
        serverTime:'',
        nameReturn:[],
        searchForm:{
          page: 1,//当前页数
          pageSize: 10,//每页显示条目个数
          total: 0, //总条目数
          testState:-1,
          psort:'',
          keyWord:'',
          userId:'',
          trainingId:''
        },
      }
    },
    computed: {
    },
    methods: {

      searchList(){
        this.searchForm.page = 1;
        this.listExamInit();
      },

      handleClick(tab){
        if(tab.label=='培训班考试'){
          this.bindType='2';
        }else if(tab.label=='我的考试'){
          this.bindType='1';
        }
      },

    },
  }

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/usercenter/MyExam.vue